module.exports = __webpack_public_path__ + "img/pwa-lorinthe-v3.79d75724.png";